import React, {useEffect, useState} from "react";
import { Container, Row, Col } from 'react-bootstrap';
import Pagination from "react-js-pagination";

import UserService from "../services/user.service";
import {Navigate} from "react-router-dom";
import {useSelector} from "react-redux";
import inventoryService from "../services/inventory.service";
import InventoryItem from "./InventoryItem";
import SearchForm from "./inventory/SearchForm";
import {ToastContainer} from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Toaster from "../common/ToastMsg";

const Inventory = () => {
    const [clients, setClients] = useState([]);
    const [selectedOption, setSelectedOption] = useState("");
    const { user: currentUser } = useSelector((state) => state.auth);
    const [inventory, setInventory] = useState([]);
    const [clientsLoading, setClientsLoading] = useState(false);
    const [inventoryLoading, setInventoryLoading] = useState(false);

    const [filterParts, setFilterParts] = useState("");
    const [filterNumber, setFilterNumber] = useState("");
    const [filterLocation, setFilterLocation] = useState("");

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentEditItem, setCurrentEditItem] = useState({id: undefined, partsId: undefined, partsName: undefined, partsNumber: undefined, location: undefined, qty: undefined});

    const [timer, setTimer] = useState(null);
    const openModal = () => {
        setCurrentEditItem({id: undefined, partsId: undefined, partsName: undefined, partsNumber: undefined, location: undefined, qty: undefined});
        setIsModalOpen(true);
    };

    const [pageRequest, setPageRequest] = useState({page: 0, size: 50});
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const [totalItems, setTotalItems] = useState(0);
    const [displayRange, setDisplayRange] = useState('');

    const urlSearchParams = new URLSearchParams(window.location.search);
    const client = urlSearchParams.get("client");

    const closeModal = (msg) => {
        if (msg) {
            Toaster.info({
                text: msg
            },{
                position: "top-center",
                containerId: "inventory",
                autoClose: 3000
            });
        }
        setIsModalOpen(false);
        refreshInventory();
    };

useEffect(() => {
    setClientsLoading(true);
    UserService.getClientList().then(
      (response) => {
        setClients(response.data);
        if (response.data instanceof Array && response.data.length > 0) {
            setSelectedOption(client || response.data[0].oid);
        }
          setClientsLoading(false);
      },
      (error) => {
          console.log(error);
          Toaster.error({
              title: "Failed to load clients !",
              text: error.message
          }, {
              position: "top-center",
              containerId: "search"
          });
          setClientsLoading(false);
      }
    )

  }, []);

  const refreshInventory = () => {
    setInventoryLoading(true);
    let newPageRequest = {...pageRequest};
    newPageRequest.clientId = selectedOption;
    
    // Clean up filterNumber: remove non-letters and non-digits, but keep # if it is not leading or trailing
    const cleanedFilterNumber = filterNumber.trim()
      .replace(/[^a-zA-Z0-9#]/g, "")  // Remove non-letters, non-digits, and non-#
      .replace(/^[0#]*/, "")          // Remove leading 0s and #s
      .replace(/#*$/, "");            // Remove trailing #s
    
    newPageRequest.searchPn = cleanedFilterNumber;
    newPageRequest.searchDescription = filterParts;
    newPageRequest.searchLocation = filterLocation;
    inventoryService.getClientInventory(newPageRequest).then(
        (response) => {
            setInventory(response.data.content);
            setTotalPages(response.data.totalPages);
            setTotalItems(response.data.totalElements);
            let start = pageRequest.page * pageRequest.size + 1;
            const end = start + response.data.content.length - 1;
            if (end === 0) start = 0;
            setDisplayRange(`${start}-${end}`);
            setInventoryLoading(false);
        },
        (error) => {
            console.log(error);
            Toaster.error({
                title: "Failed to load inventory !",
                text: error.message
            }, {
                position: "top-center",
                containerId: "search"
            });
            setInventoryLoading(false);
        }
    )
}


const handlePageChange = (pageNumber) => {
    setPageRequest(prevState => ({...prevState, page: pageNumber - 1}));
}

    const handlePageSizeChange = (event) => {
        setPageSize(event.target.value);
        setPageRequest(prevState => ({...prevState, size: event.target.value, page: 0}));
    }

  const refreshInventory1 = () => {
      setInventory([]);
      setFilterParts("");
      setFilterNumber("");
      setFilterLocation("");
  };
  useEffect(() => {
    if (!currentUser || !selectedOption) return;
    refreshInventory();
  }, [selectedOption, currentUser, pageRequest]);

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  const handleSelection = (event) => {
      handleClearFilter();
      setSelectedOption(event.target.value);
  };

    const handleFilterPartsChange = (event) => {
        setFilterParts(event.target.value);
    }

    const handleFilterNumberChange = (event) => {
        setFilterNumber(event.target.value);
    }

    const handleFilterLocationChange = (event) => {
        setFilterLocation(event.target.value);
    }

    const handleClearFilter = () => {
        setFilterParts("");
        setFilterNumber("");
        setFilterLocation("");
        setPageRequest(prevState => ({...prevState, page: 0}));
    }

    const handleApplyFilter = () => {
        setPageRequest(prevState => ({...prevState, page: 0}));
    }

    return (
        <div className="container-fluid py-4" style={{ background: 'var(--bg-gradient)', minHeight: '100vh' }}>
            <div className="card border-0 shadow-lg rounded-4 mb-4">
                <div className="card-body p-4">
                    <ToastContainer autoClose={false} containerId={"inventory"} />
                    
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h2>Inventory Manager</h2>
                        <button type="button" className="btn btn-primary rounded-pill px-4 shadow-sm" onClick={openModal}>
                            <i className="bi bi-plus-circle me-2"></i>Add New Parts
                        </button>
                    </div>

                    {isModalOpen && (
                        <SearchForm
                            closeSearch={closeModal} clientId={selectedOption} refreshInventory={refreshInventory1}
                        />
                    )}

                    <Row className="mb-4">
                        <Col xs={12} md={6}>
                            <div className="dropdown">
                                <label className="form-label text-muted mb-2">Select Client</label>
                                <select
                                    value={selectedOption}
                                    className="form-select form-select-lg shadow-sm border-0 bg-light"
                                    onChange={handleSelection}
                                    disabled={clientsLoading}
                                >
                                    {!clients &&
                                        <option value="" disabled>
                                            No client found
                                        </option>
                                    }

                                    {clients && clients.map((client, index) => (
                                        <option key={client.oid} value={client.oid}>
                                            {client.clientName}
                                        </option>
                                    ))}

                                </select>
                                {clientsLoading && (
                                    <span className="spinner-border spinner-border-sm text-primary mt-2" role="status"></span>
                                )}
                            </div>
                        </Col>
                    </Row>
                    
                    <Row>
                        <Col>
                    <div className="mt-4 table-responsive">
                        <table className="table table-hover align-middle">
                            <thead className="table-dark">
                            <tr>
                                <th scope="col" style={{ minWidth: '80px' }}>ID</th>
                                <th scope="col" style={{ minWidth: '150px' }}>Parts Number</th>
                                <th scope="col" style={{ minWidth: '250px' }}>Parts</th>
                                <th scope="col" style={{ minWidth: '150px' }}>Location</th>
                                <th scope="col" style={{ minWidth: '100px' }}>Qty</th>
                                <th scope="col" style={{ minWidth: '120px' }}>List Price</th>
                                <th scope="col" style={{ minWidth: '120px' }}>Cost</th>
                                <th scope="col" style={{ minWidth: '180px' }}>Action</th>
                            </tr>
                            </thead>
                            <tbody>

                            <tr className="table-light">
                                <td></td>
                                <td><input type="text" className="form-control form-control-sm" placeholder="Filter Number..." value={filterNumber} onChange={handleFilterNumberChange}/></td>
                                <td><input type="text" className="form-control form-control-sm" placeholder="Filter Parts..." value={filterParts} onChange={handleFilterPartsChange}/></td>
                                <td><input type="text" className="form-control form-control-sm" placeholder="Filter Location..." value={filterLocation} onChange={handleFilterLocationChange}/></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                    <div className="d-flex flex-wrap gap-2">
                                        <button className="btn btn-sm btn-primary rounded-pill px-3 shadow-sm" onClick={handleApplyFilter}>Filter</button>
                                        <button className="btn btn-sm btn-secondary rounded-pill px-3 shadow-sm" onClick={handleClearFilter}>Clear</button>
                                    </div>
                                </td>
                            </tr>

                            {inventoryLoading && (
                                <tr>
                                    <td colSpan="8" className="text-center">
                                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                        Loading inventory...
                                    </td>
                                </tr>
                            )}
                            {inventory && inventory instanceof Array && inventory.length > 0 && inventory.map((invItem, index) => (
                                <InventoryItem key={invItem.id} clientId={selectedOption} item={invItem}
                                               inv={inventory}/>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </Col>
            </Row>
                

                <Row className="mt-4 border-top pt-3">
                    <Col md={12} className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                        <div className="d-flex align-items-center mb-3 mb-md-0">
                            <span className="text-muted me-2">Items per page:</span>
                            <select
                                value={pageSize}
                                className="form-select form-select-sm w-auto"
                                onChange={handlePageSizeChange}
                            >
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                        </div>
                        
                        <div className="mb-3 mb-md-0">
                            <Pagination
                                activePage={pageRequest.page + 1}
                                itemsCountPerPage={pageRequest.size}
                                totalItemsCount={totalPages * pageRequest.size}
                                pageRangeDisplayed={10}
                                onChange={handlePageChange}
                                itemClass="page-item"
                                linkClass="page-link"
                            />
                        </div>
                        
                        <div className="text-muted small">
                            <span className="me-3">Displaying: <strong className="text-primary">{displayRange}</strong> of {totalItems}</span>
                            <span>Total Pages: <strong className="text-primary">{totalPages}</strong></span>
                        </div>
                    </Col>
                </Row>
            </div>
          </div>
        </div>
    );
};

export default Inventory;
